module.exports = __webpack_public_path__ + "img/favorites.e291b21f.svg";